import { render, staticRenderFns } from "./PoiNotes.vue?vue&type=template&id=167a6af0&"
import script from "./PoiNotes.vue?vue&type=script&lang=js&"
export * from "./PoiNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PoiNotes.vue"
export default component.exports